const locale = {
  en: {
    changeLang:'中文版',
    title:'Climbing Beta',
    sbutitle:'Collaborative, Open Data',

    news:'News',

    waiverText: [ 'All data of routes and bolts are maintained by climbers and errors are likely to exist.',
                 'Never trust your life to a single pieced of equipment.',
                 'You safety is your own responsibility.',
                ],
    agree: 'Agree',
    disagree: 'Disagree',

    version: 'Version',
    ticklist: 'Ticklist',

    login: 'Login',
    logout: 'Logout',
    cancel: 'Cancel',
    submit: 'submit',
    delete: 'Delete',
    confirmLogout: 'Confirm to logout?',
    deleteComment:'Delete comment?',
    safety:'Safety',
    bolt:{
        'OK':'OK',
        'BAD':'BAD',
        'BRK':'BREAK',
        'OUT':'PULL-OUT',
    },

    boltType:'Type',
    boltYear:'Year',
    testDate:'Test Date',
    testResult:'Status',
    Links:'Links',
    LinkAdmin:'Admin Page',
    LinkRebolt:'Re-bolting Project',
    LinkSphere:'Sphere Topo Demo',

    FA:'FA',
    FADate:'FA Date',
    AddVideo:'Add Vidoe',
    Comment:'Commet',
    AddComment:'Add Commet',
    AddCommentText:'say something...',

    MarkTick:'Tick',
    MarkNotTick:'Not Tick',
    DropSpherePhoto:'Drop the sphere photo here',
    Area:'Area',
    Region:'Region',
    Route:'Route',

    '上方架繩':'toprope',
    '傳攀':'trad',
    '傳攀多繩距':'trad multi',
    '運動':'sport',
    '運動多繩距':'sport multi',
    '抱石':'boulder',

    '紅燈':'Red',
    '黃燈':'Yellow',
    '綠燈':'Green',

    'Bolt 資訊':'Bolt Info',
    '後門':'Back Door',
    '黃金谷':'Gold Valley',
    '第二洞':'Second Cave',
    '第一洞':'First Cave',
    '大禮堂':'Grand Auditorium',
    '音樂廳':'Music Hall',
    '長巷':'Long Lane',
    '鐘塔區':'Clocktower Area',
    '校門口':'School Gate',
    '地下一樓':'B1',
    '地下室台階':'Basement Steps',
    '地下二樓':'Basement',
    '老人牆':'Old Man Wall',
    '鱷魚岬':'Crocodile Cape',
    '美好的懸岩':'P.O. Wall',
    '貓屋':'The Cathouse',
    '伸展台':'Catwalk',
    '浪之外':'Euro Wall',
    '黃金岩':'Gold Wall',
    '黑岩':'Black Wall',
    '傳奇岩':'Legend Wall',
    '比基尼洞穴':'Bikini Cave',
    '塔岩':'Tower Wall',
    '龍船岩':'Dragon Boat Wall',
    '失落的龍塔':'Lost Dragon Spire',
    '後院':'Back Porch',
    '陽光面':'Sunshine Wall',
    '入口裂隙':'Entrance Crachs',
    '雨牆':'Rain Wall',
    '洞外岩壁':'Cave Rock',
    '洞之上':'Headwall',
    '南面':'Sounth End',
    '西面':'West Wall',
    '東北面':'Northest Wall',
    '外牆':'Outer Wall',
    '龍脊背面下半部':'Lower Dragon Ridge',
    '龍脊背面上半部':'Yellow Wall',
    '上龍脊':'Upper Dragon Ridge',
    '南側(龍脊北面)':'Dragon Ridge North Face',
    '大斜板':'Great Slab',
    '凡登峽谷':'Verdon Wall',
    '龍柱':'Dragon Point Buttress',
    '龍爪、小禮堂':'Dragon Claw, Small Auditorium',
    '破碎面':'Borken Faces',
    '左面':'Left Face',
    '正面':'Main Face',
    '北面':'North Face',
    '演奏台':'Recital Hall',
    '包廂':'Balcony',
    '鯨魚頭':'Whale\'s Head',
    '佈告欄':'Bulletin Board',
    '獨木橋畔':'Wooden Bridge',
    '訓導處':'Discipline Area',
    '水池畔':'Pondside Wall',
    '左鐘塔':'Left Tower',
    '鐘塔':'Clocktower',
    '總統頭像山':'Four Presidents',
    '短巷':'Short Lane',
    '臨海面':'Sea Wall',
    '人面岩':'Disco Buttress',
    '門簷':'Apprentice Rock',
    '騙人的牆':'Illusion Wall',
  },
  ch: {
    title:'龍洞攀岩資料庫',
    sbutitle:'協同編輯，開放資料',
    news:'最新訊息',

    changeLang:'ENGLISH',
    waiverText:[ '所有路線及Bolt資料皆由岩友共同編輯,僅供攀岩者的輔助參考,無法保證資料絕對正確',
                 '在嘗試攀登任何的路線前,請評估自己的能力,使用任何一顆Bolt前,應善用你的判斷力,決定該Bolt是否可以信任',
                 '你的安全應該由自己完全負責',
                ],
    agree: '同意',
    disagree: '不同意',

    version: '版本',
    ticklist: '完攀路線',
    login: '登入',
    logout: '登出',
    cancel: '取消',
    submit: '送出',
    delete: '刪除',
    confirmLogout: '確定登出？',
    deleteComment:'刪除留言？',
    safety:'安全評級',
    bolt:{
        'OK':'合格',
        'BAD':'有問題',
        'BRK':'失敗斷裂',
        'OUT':'失敗拉出',
    },


    boltType:'類型',
    boltYear:'年份',
    testDate:'測試日期',
    testResult:'測試結果',
    Links:'相關連結',
    LinkAdmin:'管理介面',
    LinkRebolt:'龍洞Re-bolt計劃',
    LinkSphere:'環景路線圖Demo',

    FA:'首攀',
    FADate:'首攀日期',
    AddVideo:'新增影片',
    Comment:'留言',
    AddComment:'新增留言',
    AddCommentText:'說點什麼?',
    MarkTick:'完攀',
    MarkNotTick:'未完攀',
    DropSpherePhoto:'上傳環景照片，將檔案拉到這裡',
    Area:'區域',
    Region:'分區',
    Route:'路線',


  },
  toggle(){
    let lang = (locale.lang === 'ch') ? 'en' : 'ch'
    locale.set(lang)
  },

  get(key){
    return locale.R[key] || key
  },
  set(lang='ch'){
    locale.R = locale[lang]
    locale.lang = lang
  }
}

locale.R = locale.ch

export default locale



/** WEBPACK FOOTER **
 ** ./src/app/locale.js
 **/